import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=5185b05e&scoped=true&"
import script from "./Card.vue?vue&type=script&setup=true&lang=js&"
export * from "./Card.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Card.vue?vue&type=style&index=0&id=5185b05e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5185b05e",
  null
  
)

export default component.exports